module.exports = __webpack_public_path__ + "img/illustration-check.25e40130.svg";